<template>
  <section>
    <div class="columns">
      <div class="column is-12 is-paddingless">
        <div class="card events-card">
          <header
            class="card-header"
            style="align-items: center"
          >
            <p class="card-header-title">
              Workflow Summary
            </p>
            <div
              class="tags"
              style="margin-right: 1em;"
            >
              <a
                v-if="wf.is_company_workflow"
                :href="'/workflow/edit/' + wf.workflow.uuid"
                class="card-header-icon tag is-info"
                aria-label="more options"
              >
                <span class="icon">
                  <i
                    class="fas fa-pencil-alt"
                    aria-hidden="true"
                  />
                </span> &nbsp;Edit this workflow
              </a>
              <a
                v-if="wf.is_company_workflow || wf.is_legal_state_workflow"
                :href="'/workflow/add/' + wf.workflow.uuid"
                class="card-header-icon tag is-info"
                aria-label="more options"
              >
                <span class="icon">
                  <i
                    class="fas fa-plus"
                    aria-hidden="true"
                  />
                </span> &nbsp;Duplicate this workflow
              </a>
            </div>
          </header>
          <div class="card-table">
            <div class="content">
              <div class="columns">
                <div class="column is-12">
                  <br>

                  <div
                    id="stepEditor"
                    class="timeline"
                  >
                    <header class="timeline-header">
                      <span class="tag is-medium is-success">Start</span>
                    </header>

                    <div id="generatedSteps">
                      <div
                        v-for="(step, index) in wf.formatted_step"
                        :key="index"
                        class="timeline-item"
                      >
                        <div
                          class="timeline-marker is-icon"
                          style="font-family: monospace"
                        >
                          {{ index + 1 }}
                        </div>
                        <div class="timeline-content">
                          <step-view
                            :step="step"
                            :index="index"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="timeline-header">
                      <span class="tag is-medium is-success">End</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Vue from 'vue';
import StepView from './step/View.vue';
import WorkflowService from '../../services/workflow.service';

const workflowServise = new WorkflowService();
Vue.component('StepView', StepView);

export default {
  name: 'WorkflowDetails',
  data() {
    return {
      wf: {
        is_legal_state_workflow: true,
        is_company_workflow: true,
        formatted_step: [],
        workflow: {}
      }
    };
  },
  mounted() {
    this.$root.pageTitle = 'Workflow';
    const self = this;
    workflowServise.getWorkflows(this.$route.params.uuid)
      .then((response) => {
        const { status, result } = response.data;

        if (status === 'success') {
          self.wf = result;
        } else {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        }
      })
      .catch(() => {
        self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
      });
  }
};
</script>
<style scoped src='../../../public/assets/css/bulma-extension/bulma-timeline.min.css'></style>
<style scoped>
    .timeline-content {
        width: 100%;
    }

    .timeline .card {
        margin-bottom: .5em;
    }

    .columns {
        height: auto;
    }

    .content h4 {
        margin-bottom: 0;
    }
</style>
